// extracted by mini-css-extract-plugin
module.exports = {"raised-glyph":"raised-glyph_raised-glyph__dAYJU"};